import { render, staticRenderFns } from "./UserDataPlans.vue?vue&type=template&id=3e5971d5&scoped=true"
import script from "./UserDataPlans.vue?vue&type=script&lang=ts"
export * from "./UserDataPlans.vue?vue&type=script&lang=ts"
import style0 from "./UserDataPlans.vue?vue&type=style&index=0&id=3e5971d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5971d5",
  null
  
)

export default component.exports